import api, { updateToken } from 'util/Api';
import { APP_ROLES, isPaqueryPointRole } from 'constants/roles';
import API from 'constants/api';
import { put, call, all, takeLatest, take, fork } from 'redux-saga/effects';
import { logout, clearReducers } from 'redux/logout';
import { message, Modal } from 'antd';
import { actions as globalsActions } from 'redux/globals/slice';
import keycloak from 'services/Keycloak';
import { actions } from './slice';

function* fetchProfileSaga() {
  const profileResponse = yield call(api.apiAxios.get, API.profile.load);
  if (!api.isSuccessResponse(profileResponse)) {
    throw new Error(
      `Error al obtener el perfil del usuario${
        profileResponse.data.message ? `: ${profileResponse.data.message}` : '.'
      }`,
    );
  }
  const profile = profileResponse.data.data;
  if (!APP_ROLES.some((allowedRole) => allowedRole === profile.userRoleID)) {
    throw new Error(
      'El usuario no es operador ni administrador de OPL o PaQuery Point',
    );
  }
  // Sólo los roles de PaQuery Point están atados a un PP concreto. Los roles de
  // OPL operan sobre todos los PPs del operador, así que no exigimos el vínculo.
  if (!isPaqueryPointRole(profile.userRoleID)) {
    return profile;
  }
  if (!profile.paqueryPointID) {
    throw new Error(
      'Tu usuario no tiene asignado un paquerypoint. Consultar al administrador.',
    );
  }
  const paquerypointResponse = yield call(
    api.apiAxios.get,
    API.profile.paquerypointInfo(profile.paqueryPointID),
  );
  if (!api.isSuccessResponse(paquerypointResponse)) {
    throw new Error(
      'Error al obtener los datos del paquerypoint, intente de nuevo.',
    );
  }
  delete profile.paqueryPointID;
  profile.paquerypoint = paquerypointResponse.data.data;
  return profile;
}

function* fetchLoggedUserSaga() {
  try {
    const profile = yield call(fetchProfileSaga);
    yield put({ type: actions.fetchProfileSuccess.type, payload: profile });
  } catch (error) {
    yield put({ type: actions.fetchProfileFailure.type });
    message.error(error.message);
  }
}

function* loginWithTokenSaga({ payload: token }) {
  try {
    updateToken(token);
    const profile = yield call(fetchProfileSaga);
    yield put({
      type: actions.success.type,
      payload: { profile, sessionToken: token },
    });
  } catch (error) {
    Modal.error({
      title: 'No se pudo iniciar sesión',
      content: error.message,
      okText: 'Volver al login',
      onOk: () => keycloak.logout(),
    });
  }
}

function* watchLogout() {
  while (true) {
    yield take([
      logout.type,
      actions.failure.type,
      actions.fetchProfileFailure.type,
    ]);
    yield put({ type: clearReducers.type });
    yield call([keycloak, keycloak.logout]);
  }
}

function* reloadTimeZone() {
  yield put({ type: globalsActions.success.type });
}

export default function* rootSaga() {
  yield all([
    yield fork(watchLogout),
    yield takeLatest(actions.loginWithToken, loginWithTokenSaga),
    yield takeLatest(actions.reloadProfile, fetchLoggedUserSaga),
    yield takeLatest(actions.reloadProfile, reloadTimeZone),
  ]);
}
